import { Card, Grid, Empty } from "antd";
import { useDataReviewLogic } from "../../hooks/useDataReviewLogic";
import { useColumnSelection } from "../../hooks/useColumnSelection";
import { useAnalyticsConfiguration } from "../../hooks/useAnalyticsConfiguration";
import ColumnSelectionCard from "./ColumnSelectionCard";
import AnalyticsConfigurationCard from "./AnalyticsConfigurationCard";
import AnalyticsProgressModal from "../AnalyticsProgressModal";
import DataHistoryPageHeader from "./DataHistoryPageHeader";
import { useEffect, useRef } from "react";
import { generativeEngineInsightsResultThunk } from "../../store/slices/fileSlice";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";

const { useBreakpoint } = Grid;

const DataReviewAndConfigure = () => {
  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const file_name = useSelector((s) => s.file?.uploadedFilePath);
  const generativeEngineInsightsResult = useSelector((s) => s.file?.generativeEngineInsightsResult);
  const insightsGenerating = useSelector((s) => s.file?.insightsGenerating);
  const lastFetchedIdRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
       if (!file_name) return;
       if (generativeEngineInsightsResult || insightsGenerating) return;
       if (lastFetchedIdRef.current === file_name) return;
       lastFetchedIdRef.current = file_name;

        try {
          // The thunk will update the Redux store, which other components listen to.
          await dispatch(generativeEngineInsightsResultThunk({file_name: file_name })).unwrap();
        } catch (err) {
          lastFetchedIdRef.current = null;
          console.error("Failed to fetch generative engine insights:", err);
          message.error(err?.message || "Failed to fetch insights");
        }
      };

      fetchData();
  }, [dispatch, file_name, generativeEngineInsightsResult, insightsGenerating]);

  const {
    processResponse,
    applying,
    applyResponse,
    hasProcessResponse,
    onBack,
    onConfigure,
    onBackToDashboard,
    onCancel
  } = useDataReviewLogic();

  const {
    columns,
    numericColumns,
    allColumns,
  } = useColumnSelection(processResponse);

  const {
    modalSelection,
    dependentVariable,
    groupBy,
    onChangeModal,
    onChangeDependent,
    onChangeGroupBy,
    dependentOptions,
    groupByOptions,
    MODEL_OPTIONS,
    ENSEMBLE_MODELS,
  } = useAnalyticsConfiguration(columns, numericColumns, allColumns);

  return (
    <div className="min-h-[100dvh] relative">
      <DataHistoryPageHeader screens={screens} onBack={onBack} />

      <AnalyticsProgressModal
        processing={applying}
        activeStep={applying ? 3 : 0}
        totalSteps={4}
        disableClose
        modalSelection={modalSelection}
        dependentVariable={dependentVariable}
        groupBy={groupBy}
        MODEL_OPTIONS={MODEL_OPTIONS}
        onCancel={onCancel}
      />

      <div className="p-4 sm:p-6">
        {!hasProcessResponse ? (
          <Card className="shadow-sm">
            <div className="py-20 flex items-center justify-center">
              <Empty description="No response found" />
            </div>
          </Card>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ColumnSelectionCard columns={columns} />
            <AnalyticsConfigurationCard
              modalSelection={modalSelection}
              dependentVariable={dependentVariable}
              groupBy={groupBy}
              onChangeModal={onChangeModal}
              onChangeDependent={onChangeDependent}
              onChangeGroupBy={onChangeGroupBy}
              dependentOptions={dependentOptions}
              groupByOptions={groupByOptions}
              onConfigure={onConfigure}
              applying={applying}
              applyResponse={applyResponse}
              MODEL_OPTIONS={MODEL_OPTIONS}
              ENSEMBLE_MODELS={ENSEMBLE_MODELS}
              onBackToDashboard={onBackToDashboard}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DataReviewAndConfigure;